var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.54492,
    y: 22.7558,
    width: 4.01403,
    height: 15.1992,
    transform: "rotate(-135 3.54492 22.7558)",
    stroke: "url(#paint0_linear_458_1023)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.707107,
    width: 4.01403,
    height: 15.1992,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 3.04492 0.591384)",
    stroke: "url(#paint1_linear_458_1023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_1023",
    x1: 8.35693,
    y1: -45.858,
    x2: -30.9523,
    y2: 38.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_1023",
    x1: 4.812,
    y1: -69.3209,
    x2: -34.4972,
    y2: 15.5346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArr);
export default __webpack_public_path__ + "static/media/right_arr.4cff1d16e5a998c3bc84d159dbc5f4c7.svg";
export { ForwardRef as ReactComponent };